import React from 'react'
import moment from 'moment'
import { DatePicker } from 'antd';

export default class NoCurrentDatePicker extends React.Component {

  getValue(value) {
    const { field, EndDate } = this.props
    const format = field.datetimeFormat || 'YYYY-MM-DD HH:mm:ss'
    return value && value.format(format) || undefined
  }

  onChange = (value) => {
    const { input } = this.props
    input.onChange(this.getValue(value))
  }
  disabledEndDate = (endValue) => {
    const { EndDate } = this.props
    const startValue = EndDate && moment().subtract(1, 'days');
    if (!endValue || !startValue) {
      return false;
    }
    return endValue.valueOf() <= startValue.valueOf();
  }

  render() {
    const { input, field } = this.props
    const format = field.datetimeFormat || 'YYYY-MM-DD HH:mm:ss'
    return <DatePicker onChange={this.onChange} disabledDate={this.disabledEndDate} showTime
      value={input.value ? moment(input.value) : null} format={format} placeholder="选择日期" />
  }
}
